import { TYPE_NUMBER } from './input-types';

export const id = 'orderSubtotal';
export const apiKey = 'OrderSubtotal';
export const type = TYPE_NUMBER;

export const orderSubtotal = {
  id,
  apiKey,
  type,
};
